import { FeePlansState } from "./fee-plans.state";
import { ActionTypes } from "./fee-plans.actions";

export const FeePlansReducer = (
    state: FeePlansState = new FeePlansState(),
    action: any,
  ): FeePlansState => {

    switch (action.type) {

        case ActionTypes.GetFeePlans: {
            return {
                ...state,
                loading: true
            };
        }

        case ActionTypes.GetFeePlansSucceed: {
            const morePagesMode = (action.response.totalPages == null);
            return {
                ...state,
                record: action.response.items,
                pager: {
                    pageSize: action.pageSize,
                    page: action.page,
                    pageCount: morePagesMode ? action.response.morePages : action.response.totalPages,
                    morePagesMode
                },
                loading: false,
                error: null,
                ...action.stateExtensions
            };
        }

        case ActionTypes.GetFeePlansFail: {
            return {
                ...state,
                record: [],
                loading: false,
                error: action.error
            };
        }

        case ActionTypes.SortFeePlans: {
            return {
                ...state,
                sorting: action.sorting
            };
        }

        default: {
            return state;
        }
    }

};
